/* Gamdru: timer decorativo "Carrito reservado por X minutos" en el
 * carrito lateral. No reserva stock de verdad, es solo un empujón de
 * urgencia — se guarda una fecha de expiración en sessionStorage para
 * que la cuenta atrás sea coherente cada vez que se abre el carrito
 * durante la misma sesión de navegación, en vez de reiniciarse. */
(function () {
  var STORAGE_KEY = 'gvpCartReservationExpiresAt';

  function getExpiry(durationSeconds) {
    var stored = null;
    try {
      stored = sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {}

    var now = Date.now();
    if (stored) {
      var expiresAt = parseInt(stored, 10);
      if (expiresAt > now) return expiresAt;
    }

    var expiresAt = now + durationSeconds * 1000;
    try {
      sessionStorage.setItem(STORAGE_KEY, String(expiresAt));
    } catch (e) {}
    return expiresAt;
  }

  function format(seconds) {
    var m = Math.floor(seconds / 60);
    var s = seconds % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function init(el) {
    if (el.hasAttribute('data-gcd-init')) return;
    el.setAttribute('data-gcd-init', '');

    var duration = parseInt(el.getAttribute('data-duration'), 10) || 600;
    var valueEl = el.querySelector('[data-cart-reservation-timer-value]');
    if (!valueEl) return;
    var expiresAt = getExpiry(duration);

    var tick = function () {
      var remaining = Math.round((expiresAt - Date.now()) / 1000);
      if (remaining <= 0) {
        el.setAttribute('data-cart-reservation-timer-expired', '');
        clearInterval(interval);
        return;
      }
      valueEl.textContent = format(remaining);
    };

    tick();
    var interval = setInterval(tick, 1000);
  }

  function scan() {
    document.querySelectorAll('[data-cart-reservation-timer]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // El carrito se re-renderiza (Section Rendering API) cada vez que
  // cambia el contenido, así que vigilamos por si aparece un timer nuevo.
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
